import { v4 as uuidv4 } from "uuid";
import { IConnectorFreeswitchRobot, IConnectorMax, IConnectorNats, IConnectorTelegram, IConnectorVk, IConnectorWebChat } from "@/types/ses/sesConnectorTypes";
import { IInterval } from "@/types/ses/sesRobotTypes";
import {
	IActionBreak,
	IActionConfirmation,
	IActionDeclineData,
	IActionEnd,
	IActionExternal,
	IActionGoTo,
	IActionInternalAsk,
	IActionInternalChat,
	IActionPhrase,
	IActionSendFile,
	IActionSetReport,
	IActionSetVariable,
	IActionTransfer,
	IElement,
	IEndpoint,
} from "@/types/ses/sesItemConfigTypes";

export const DATA_ELEMENT: IElement = {
	id: "",
	name: "",
	type: "smc",
	rtype: "report",
	subtype: "class",
	model: "",
	script: "",
	param: "",
	actions: {},
	exceptions: {},
	getOnlyAsNearest: false,
	injectToMessage: false,
	removeFromMessage: false,
	// useOnceOnly: false,
	slaveData: [],
	matches: {},
	weight: 3,
	longWaiting: false,
	dataWaiting: [],
};

export const ENDPOINT: IEndpoint = {
	id: "",
	name: "",
	type: "report",
	run: [],
	actions: {},
	exceptions: {},
	entryType: "conditions",
	entry: [],
};

export const CONNECTOR_FREESWITCH: IConnectorFreeswitchRobot = {
	serviceMode: "robot",
	destination: "",
	assistant: "",
	endpoint: "",
	autostart: false,
};

export const CONNECTOR_NATS: IConnectorNats = {
	host: "",
	// inboundSubject: "",
	// outboundSubject: "",
	handler: "",
	server: "",
	port: "4222",
};

export const CONNECTOR_MAX: IConnectorMax = {
	botName: "",
	reset: "",
	token: "",
	server: "",
	pollingInterval: 3,
	variables: {},
	whitelist: {},
	activators: [],
};

export const CONNECTOR_TELEGRAM: IConnectorTelegram = {
	botName: "",
	reset: "",
	token: "",
	server: "",
	pollingInterval: 3,
	variables: {},
	whitelist: {},
	activators: [],
};

export const CONNECTOR_VK: IConnectorVk = {
	botName: "",
	reset: "",
	groupId: "",
	token: "",
	server: "",
	pollingInterval: 3,
	variables: {},
	whitelist: {},
	activators: [],
};

export const CONNECTOR_WEB: IConnectorWebChat = {
	type: "chat",
	domain: "",
	token: "",
	color: "",
	header: "",
	inittext: "",
	language: "",
	audioAnswers: true,
	sendFile: true,
	microphone: true,
	audioCall: true,
	host: [],
	variables: {},
};

export const ACTION_SAY: IActionPhrase = {
	actionId: uuidv4(),
	action: "say",
	voice: "",
	type: "linear",
	text: [""],
	interruptible: false,
};
export const ACTION_END: IActionEnd = {
	actionId: uuidv4(),
	action: "end",
};
export const ACTION_TRANSFER: IActionTransfer = {
	actionId: uuidv4(),
	action: "transfer",
	destination: "",
};
export const ACTION_SEND_FILE: IActionSendFile = {
	actionId: uuidv4(),
	action: "sendfile",
	filename: "",
	file_id: "",
	interruptible: false,
};
export const ACTION_DECLINE_DATA: IActionDeclineData = {
	actionId: uuidv4(),
	action: "declinedata",
	id: "",
	reask: false,
	param: "",
};
export const ACTION_CONFIRMATION: IActionConfirmation = {
	actionId: uuidv4(),
	action: "confirmation",
	voice: "",
	type: "linear",
	text: [""],
	interruptible: false,
};
export const ACTION_BREAK: IActionBreak = {
	actionId: uuidv4(),
	action: "break",
};
export const ACTION_SET_VARIABLE: IActionSetVariable = {
	actionId: uuidv4(),
	action: "setvariable",
	variable: "",
	operation: "set",
	value: "",
};
export const ACTION_GO_TO: IActionGoTo = {
	actionId: uuidv4(),
	action: "goto",
	endpoint: "",
};
export const ACTION_SET_REPORT: IActionSetReport = {
	actionId: uuidv4(),
	action: "setreport",
	index: "",
	name: "",
	value: "",
	operation: "set",
};
export const ACTION_EXTERNAL: IActionExternal = {
	actionId: uuidv4(),
	action: "say",
	type: "external",
	script: "",
	voice: "",
	interruptible: false,
};
export const ACTION_QAS_ASK: IActionInternalAsk = {
	actionId: uuidv4(),
	action: "say",
	type: "internal",
	service: "qas-ask",
	model: "default",
	voice: "",
	interruptible: false,
	useCache: "checked",
	useGPT: "no",
	addAlias: "no",
	categories: {},
	longContext: [],
};
export const ACTION_QAS_CHAT: IActionInternalChat = {
	actionId: uuidv4(),
	action: "say",
	type: "internal",
	service: "qas-chat",
	model: "default",
	voice: "",
	interruptible: false,
	depth: 3,
};

export const TIME_INTERVAL: IInterval = {
	days: "all",
	weekdays: new Array(7).fill(1).map((item, idx) => item + idx),
	months: new Array(12).fill(1).map((item, idx) => item + idx),
	dates: new Array(31).fill(1).map((item, idx) => item + idx),
	intervals: [[0, 1439]],
};
